import { Box, Typography } from "@mui/material";
import { memo } from "react";

import type { InstagramInfoTileProps } from "./InstagramInfoTile.types";
import * as styles from "./InstagramInfoTile.styles";

export type { InstagramInfoTileProps, InstagramInfoTileTone } from "./InstagramInfoTile.types";

export const InstagramInfoTile = memo(function InstagramInfoTile({
  icon: TileIcon,
  label,
  value,
  tone = "neutral",
  action,
}: InstagramInfoTileProps) {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.iconTile(tone)}>
        <TileIcon size={19} variant="Bulk" color="currentColor" />
      </Box>
      <Box sx={styles.text}>
        <Typography sx={styles.label}>{label}</Typography>
        <Typography sx={styles.value}>{value}</Typography>
        {action ? <Box sx={styles.action}>{action}</Box> : null}
      </Box>
    </Box>
  );
});
